// Override Settings
var bcSfSearchSettings = {
    search: {
        //suggestionMode: 'test',
        suggestionPosition: 'right',
      suggestionMobileStyle: 'style2'
    }
};

// Customize style of Suggestion box
BCSfFilter.prototype.customizeSuggestion = function(suggestionElement, searchElement, searchBoxId) {
    if (jQ(searchBoxId).parent().hasClass('header-bar__search-form')) {
      	suggestionElement.outerWidth(300);
	}
};

// Initialize Search box with Autocomplete
BCSfFilter.prototype.initSearchBox = function(id) {
    if (this.getSettingValue('search.enableSuggestion')) {
        var self = this;
        if (typeof id === 'undefined') {
            jQ('input[name="' + this.searchTermKey + '"]').each(function(i) {
                if (!jQ(this)[0].hasAttribute('data-no-bc-search')) {
                    var id = 'bc-sf-search-box-' + i;
                    jQ(this).attr({
                        'id': id,
                        'aria-live': 'polite'
                        //'placeholder': self.getSettingValue('label.suggestion.searchBoxPlaceholder')
                    });
                    self.buildSearchBox('#' + id)
                }
            });
        } else {
            this.buildSearchBox(id);
        }
        if (this.isMobile()) {
            // Clear cache when going back from another page
            window.onpageshow = function(event) {
                if (event.persisted) {
                    window.location.reload();
                }
            };
            // Build Suggestion mobile on top
            if (this.getSettingValue('search.suggestionMobileStyle') == 'style1') {
                this.buildSuggestionMobile();
            }
        }
    }
};